// extracted by mini-css-extract-plugin
module.exports =  {"variant":"ProductVariant-U6vn__variant"};